import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createBlock(_component_v_row, { align: "center" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_col, {
        cols: "12",
        class: "pb-0"
      }, {
        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
          _createElementVNode("small", null, "Filtrer les coupons par type.", -1)
        ]))]),
        _: 1
      }),
      _createVNode(_component_v_col, { cols: "auto" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.types, (type, index) => {
                return (_openBlock(), _createBlock(_component_v_col, {
                  cols: "auto",
                  key: `${type.id}-${index}`
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_checkbox, {
                      modelValue: _ctx.selectedTypes,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedTypes) = $event)),
                      label: type.code,
                      value: type.id,
                      density: "compact",
                      "hide-details": true,
                      color: "primary"
                    }, null, 8, ["modelValue", "label", "value"])
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_col, {
        cols: "12",
        lg: "2"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_btn, {
            onClick: _ctx.filterCoupons,
            color: "primary",
            block: "",
            disabled: _ctx.selectedTypes.length === 0
          }, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
              _createTextVNode("Appliquer", -1)
            ]))]),
            _: 1
          }, 8, ["onClick", "disabled"])
        ]),
        _: 1
      }),
      (_ctx.selectedTypes.length === 0)
        ? (_openBlock(), _createBlock(_component_v_col, {
            key: 0,
            cols: "12",
            class: "pt-0"
          }, {
            default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
              _createElementVNode("small", { class: "text-error" }, "Must select at least 1 type.", -1)
            ]))]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}